export default "__VITE_ASSET__xeop6Uz7__"